<ng-container *ngIf="(finishedDocumentActors && finishedDocumentActors.length > 0) || finishedXbrlSigner">
    <div class="documentsummary-actor-history">
        <div class="row row-cols-12 row-cols-sm-12 row-cols-md-12 row-cols-xl-12">
            <div class="d-inline-block">
                <!-- Show the information of completed Actors  -->
                <span *ngIf="finishedDocumentActors.length > 0" class="d-block">
                    <ng-container *ngFor="let finishedActor of finishedDocumentActors">
                        <ng-container *ngIf="shouldDisplayRegularAction(finishedActor)">
                            <!-- 'id={{}}' Needed for the Action badge line thingie -->
                            <span class="finishedActor d-block documentsummary-actor-line"
                                id="{{GenerateActionId(finishedActor)}}">
                                <i class="text-success bi bi-large bi-check-lg pe-2"></i>
                                <span translate="Request.View.Summary.Completed{{ finishedActor.action}}By"
                                    [translateParams]="{action: finishedActor.action,actorName: finishedActor.fullName, approvalDate: getFormattedDate(finishedActor.signingDate)}">
                                </span>
                            </span>
                        </ng-container>
                        <ng-container *ngIf="shouldDisplayAdoptNoAction(finishedActor)">
                            <!-- 'id={{}}' Needed for the Action badge line thingie -->
                            <span class="finishedActor d-block documentsummary-actor-line"
                                id="{{GenerateActionId(finishedActor)}}">
                                <i class="text-danger bi bi-large bi-x-lg pe-2"></i>
                                <span translate="Request.View.Summary.CompletedSkipAdoptionBy"
                                    [translateParams]="{action: finishedActor.action,actorName: finishedActor.fullName, approvalDate: getFormattedDate(finishedActor.signingDate)}">
                                </span>
                            </span>
                        </ng-container>
                    </ng-container>
                    <div></div>
                </span>
                <!-- Show the information of the Xbrl Signer -->
                <ng-container *ngIf="finishedXbrlSigner">
                    <div></div>
                    <!-- Actual info-->
                    <!-- 'id={{}}' Needed for the Action badge line thingie -->
                    <span>
                        <i class="text-success bi bi-large bi-check-lg pe-2"></i>
                        <span translate="Request.View.Summary.CompletedSignBy"
                            id="{{GenerateActionId(finishedXbrlSigner)}}"
                            [translateParams]="{action: finishedXbrlSigner.action,actorName: finishedXbrlSigner.fullName, signingDate: getFormattedDate(finishedXbrlSigner.signingDate)}">
                        </span>
                    </span>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>